import React from "react";
import { Navigate } from "react-router-dom";
import RepertoireManagement from "../app/modules/Kms/repertoire/RepertoireManagement";
import {
    KmsArchivePage,
    KmsCollaboratorContentDetailsPage,
    KmsCollaboratorContentPage,
    KmsCollaboratorDocumentDetailsPage,
    KmsCollaboratorDocumentPage,
    KmsCollaboratorHomePage,
    KmsCollaboratorSearchPage,
    KmsContentDetailsPage,
    KmsContentManagementPage,
    KmsContentWorkflowPage,
    KmsDocumentDetailsPage,
    KmsDocumentMediaManagementPage,
    KmsSearchPage,
    KmsTaxonomyPage,
    KmsTrashPage,
} from "../app/modules/Kms/pages/KmsPages";
import AppErrorBoundary from "../components/common/AppErrorBoundary";

const withBoundary = (element) => (
    <AppErrorBoundary>
        {element}
    </AppErrorBoundary>
);

export const kmsRoutes = [

    { path: "/kms", element: <Navigate to="/kms/repertoires/admin" replace /> },
    { path: "/kms/collaborateur", element: withBoundary(<KmsCollaboratorHomePage />) },
    { path: "/kms/collaborateur/contenus", element: withBoundary(<KmsCollaboratorContentPage />) },
    { path: "/kms/collaborateur/documents", element: withBoundary(<KmsCollaboratorDocumentPage />) },
    { path: "/kms/collaborateur/search", element: withBoundary(<KmsCollaboratorSearchPage />) },
    { path: "/kms/collaborateur/contenus/:contentId", element: withBoundary(<KmsCollaboratorContentDetailsPage />) },
    { path: "/kms/collaborateur/documents/:documentId", element: withBoundary(<KmsCollaboratorDocumentDetailsPage />) },
    { path: "/kms/collaborateur/documents/:documentId/preview", element: withBoundary(<KmsCollaboratorDocumentDetailsPage />) },
    { path: "/kms/repertoires/admin", element: withBoundary(<RepertoireManagement />) },
    { path: "/kms/contenus", element: withBoundary(<KmsContentManagementPage />) },
    { path: "/kms/contenus/:contentId", element: withBoundary(<KmsContentDetailsPage />) },
    { path: "/kms/documents-medias", element: withBoundary(<KmsDocumentMediaManagementPage />) },
    { path: "/kms/documents/:documentId", element: withBoundary(<KmsDocumentDetailsPage />) },
    { path: "/kms/documents/:documentId/preview", element: withBoundary(<KmsDocumentDetailsPage />) },
    { path: "/kms/search", element: withBoundary(<KmsSearchPage />) },
    { path: "/kms/contenus/traitement", element: withBoundary(<KmsContentWorkflowPage />) },
    { path: "/kms/archive", element: withBoundary(<KmsArchivePage />) },
    { path: "/kms/trash", element: withBoundary(<KmsTrashPage />) },
    { path: "/kms/contenus/taxonomie", element: withBoundary(<KmsTaxonomyPage />) },

];
